import React, { useCallback, useMemo } from "react";
import styles from "./Styles.module.css";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import useAssociatedClientsListHook from "./AssociatedClientsList.hook";
import StatusPill from "../../../../../components/Status/StatusPill.component";
import FilterComponent from "../../../../../components/Filter/Filter.component";
import {  IconButton, Typography } from "@mui/material";
import {
    Info, Add
} from "@mui/icons-material";
import { ArrowPrimaryButton } from "../../../../../components/Buttons/PrimaryButton";
import useRoles from "../../../../../hooks/RoleHook";
import Constants from "../../../../../config/constants";
import bin from "../../../../../assets/CRMAssets/ic_delete@2x.png";
//import settings from "../../../../../assets/CRMAssets/ic_maange_privilege@2x.png";
//import DissociateClientDialog from "./DissociateClientDialog/DisssociateClient.view";
//import AssociateClientDialog from "./AssociateClientsDialog/AssociateClients.view";

const AssociatedClientsListTable = ({}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
    configFilter,
    handleEdit,
    handlePrivileges,
    handleSearchValueChange,
    handleFilterDataChange,
    handleDelete,
  isDeleteOpen,
  isAssociateOpen,
  handleAssociate,

  } = useAssociatedClientsListHook({});
  const { canRead} = useRoles(Constants.MODULES.ADMIN_USERS);

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"ACTIVE"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"INACTIVE"} color={"high"} />;
    } else if (status === "SCHEDULED") {
      return <StatusPill status={"SCHEDULED"} color={"medium"} />;
    }
  }, []);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "title",
        label: "Client Name",
        sortable: false,
        render: (temp, all) => (
          <div>
            {all?.name}
          </div>
        ),
      },
      
      {
        key: "timestamp",
        label: "Description",
        sortable: false,
        render: (temp, all) => <div>{all?.description ?? "N/A"}</div>,
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      },
      ...(canRead ? [{
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
            {canRead &&<IconButton
      disableRipple="false"
      onClick={() => {
        
        handleEdit(all);
      }}
    >
      <Info
        fontSize={"small"}
       
      />
    </IconButton>}
    {/* <IconButton
              
              onClick={() => handlePrivileges()}
            >
             <img src={settings} alt="copy" className={styles.copy}/>
            </IconButton> */}
    {/* <IconButton
             onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
            >
             <img src={bin} alt="copy" className={styles.copy}/>
            </IconButton> */}
          </div>
        ),
      },]:[])
    ];
  }, [isCalling, renderStatus]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <div className={styles.mainContainer}>
      <div className={styles.row1}>
        <Typography
          variant={"h5"}
          className={styles.productHeading}
          color={"text.primary"}
        >
          {" "}
          Associated Clients
        </Typography>
        {/* <ArrowPrimaryButton
           onClick={(e) => {
            e.stopPropagation();
            handleAssociate();
          }}
          icon={<Add fontSize="normal" />}
        >
          ASSOCIATE CLIENTS
        </ArrowPrimaryButton> */}
        
      
      </div>
      {/* <DissociateClientDialog
      isDeleteOpen={isDeleteOpen}
      handleDelete={handleDelete}
      />
      <AssociateClientDialog
      isAssociateOpen={isAssociateOpen}
      handleAssociate={handleAssociate}
      /> */}
      <FilterComponent
          // disabled={editData ? true : false}
          filters={[]}
          is_progress={false}
          // filters={configFilter}
         // handleFilterDataChange={handleFilterDataChange}
          handleSearchValueChange={handleSearchValueChange}
          placeholder="Search by client name"
        />
      <br />
      

      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </div>
  );
};

export default AssociatedClientsListTable;
